module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "board"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "board-bar"
  }, [_c('div', [_c('div', {
    staticClass: "board-range"
  }, [_vm._v(_vm._s(_vm.rangeLabel))]), _vm._v(" "), _c('div', {
    staticClass: "board-stat"
  }, [_vm._v("\n        本周共 " + _vm._s(_vm.stats.total) + " 场已安排面试 · " + _vm._s(_vm.stats.confirmed) + " 场已确定 · " + _vm._s(_vm.stats.unbooked) + " 待预约 ·\n        空格点击 + 新增 · 已有面试的格子可再点 + 叠加\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "board-nav"
  }, [_c('Button', {
    attrs: {
      "size": "small",
      "icon": "chevron-left"
    },
    on: {
      "click": function($event) {
        return _vm.moveWeek(-7)
      }
    }
  }), _vm._v(" "), _c('Button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.goThisWeek
    }
  }, [_vm._v("本周")]), _vm._v(" "), _c('Button', {
    attrs: {
      "size": "small",
      "icon": "chevron-right"
    },
    on: {
      "click": function($event) {
        return _vm.moveWeek(7)
      }
    }
  }), _vm._v(" "), _c('Button', {
    attrs: {
      "size": "small",
      "icon": "refresh",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.load
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "board-grid-wrap"
  }, [(_vm.loading) ? _c('Spin', {
    attrs: {
      "fix": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "board-grid"
  }, [_c('div', {
    staticClass: "cell cell-head cell-time"
  }, [_vm._v("Time")]), _vm._v(" "), _vm._l((_vm.weekDays), function(day, i) {
    return _c('div', {
      key: day.ymd,
      staticClass: "cell cell-head",
      class: {
        'is-today': day.ymd === _vm.todayYmd
      }
    }, [_c('div', [_vm._v(_vm._s(_vm.dayLabels[i]))]), _vm._v(" "), _c('div', {
      staticClass: "cell-date"
    }, [_vm._v(_vm._s(day.md))])])
  }), _vm._v(" "), _vm._l((_vm.slots), function(ts) {
    return [_c('div', {
      key: 't' + ts.startMin,
      staticClass: "cell cell-time"
    }, [_vm._v(_vm._s(ts.label))]), _vm._v(" "), _vm._l((_vm.weekDays), function(day, dayIdx) {
      return _c('div', {
        key: dayIdx + '-' + ts.startMin,
        staticClass: "cell cell-body"
      }, [(!_vm.slotItems(dayIdx, ts.startMin).length) ? _c('button', {
        staticClass: "slot-add",
        attrs: {
          "type": "button",
          "title": "新增面试"
        },
        on: {
          "click": function($event) {
            return _vm.openAdd(day, ts.startMin)
          }
        }
      }, [_vm._v("+")]) : [_vm._l((_vm.slotItems(dayIdx, ts.startMin)), function(t) {
        return _c('div', {
          key: t.tchId,
          staticClass: "slot-card",
          class: {
            'is-unbooked': _vm.isUnbooked(t)
          },
          on: {
            "click": function($event) {
              return _vm.$emit('open-tch', t)
            }
          }
        }, [_c('a', {
          staticClass: "slot-clear",
          attrs: {
            "title": "清除此时段"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.clear(t)
            }
          }
        }, [_c('Icon', {
          attrs: {
            "type": "close"
          }
        })], 1), _vm._v(" "), _c('div', {
          staticClass: "slot-name",
          attrs: {
            "title": t.tchId + ' ' + _vm.nameOf(t)
          }
        }, [_vm._v(_vm._s(t.tchId) + " " + _vm._s(_vm.nameOf(t)))]), _vm._v(" "), _c('div', {
          staticClass: "slot-state"
        }, [_vm._v(_vm._s(_vm.isUnbooked(t) ? '未预约 / Not booked' : '已确定 / Confirmed'))])])
      }), _vm._v(" "), _c('button', {
        staticClass: "slot-add is-more",
        attrs: {
          "type": "button",
          "title": "再新增一位"
        },
        on: {
          "click": function($event) {
            return _vm.openAdd(day, ts.startMin)
          }
        }
      }, [_vm._v("+")])]], 2)
    })]
  })], 2), _vm._v(" "), (_vm.outsideItems.length) ? _c('div', {
    staticClass: "board-outside"
  }, [_c('span', {
    staticClass: "outside-title"
  }, [_vm._v("不在 14:00-21:30 时段内的面试：")]), _vm._v(" "), _vm._l((_vm.outsideItems), function(t) {
    return _c('Tag', {
      key: t.tchId,
      attrs: {
        "closable": ""
      },
      on: {
        "on-close": function($event) {
          return _vm.clear(t)
        }
      }
    }, [_c('a', {
      on: {
        "click": function($event) {
          return _vm.$emit('open-tch', t)
        }
      }
    }, [_vm._v(_vm._s(t.tchId) + " " + _vm._s(_vm.nameOf(t)))]), _vm._v(" " + _vm._s(t.interviewTime) + "\n      ")])
  })], 2) : _vm._e()], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "安排面试到此时段",
      "mask-closable": false
    },
    model: {
      value: (_vm.addVisible),
      callback: function($$v) {
        _vm.addVisible = $$v
      },
      expression: "addVisible"
    }
  }, [(_vm.addSlot) ? _c('p', {
    staticClass: "add-slot-text"
  }, [_vm._v(_vm._s(_vm.addSlot.ymd) + " · " + _vm._s(_vm.addSlot.label))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "add-label"
  }, [_vm._v("选择老师")]), _vm._v(" "), _c('Select', {
    attrs: {
      "filterable": "",
      "transfer": "",
      "placeholder": "请选择待面试老师"
    },
    model: {
      value: (_vm.pickedTchId),
      callback: function($$v) {
        _vm.pickedTchId = $$v
      },
      expression: "pickedTchId"
    }
  }, _vm._l((_vm.candidates), function(t) {
    return _c('Option', {
      key: t.tchId,
      attrs: {
        "value": t.tchId,
        "label": t.tchId + ' · ' + _vm.nameOf(t)
      }
    }, [_vm._v("\n        " + _vm._s(t.tchId) + " · " + _vm._s(_vm.nameOf(t)) + _vm._s(t.interviewTime ? '（已有安排，将改期）' : '') + "\n      ")])
  }), 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.addVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saving
    },
    on: {
      "click": _vm.confirmAdd
    }
  }, [_vm._v("确认安排")])], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "board-head"
  }, [_c('div', [_c('div', {
    staticClass: "board-title"
  }, [_vm._v("面试时间表")]), _vm._v(" "), _c('div', {
    staticClass: "board-sub"
  }, [_vm._v("按自然周查看每日面试安排")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06563332","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/teacher/recruit/RecruitScheduleBoard.vue
// module id = 1604
// module chunks = 8